import store from 'Store'
import i18n from '@/i18n'
import Nprogress from 'nprogress'
// Helpers
import { loadCurretUser } from '@/services/helpers'
import { networkErrorPage } from '../helpers'

export default [
  {
    // Client DASHBOARD
    path: 'account/:account_id',
    name: 'dashboard-client',
    meta: { user: 'client' },
    async beforeEnter(to, from, next) {
      Nprogress.start()
      const currentUser = loadCurretUser()
      const isClient = currentUser.type === 'CLIENT'
      const accountId = isClient ? currentUser.account.id : to.params.account_id
      try {
        // loading client
        await store.dispatch('client/load', accountId)
        // In case the account ID is manually changed in the URL
        // we make sure the id matches the client who's logged in.
        if (isClient) {
          if (to.params.account_id == currentUser.account.id) {
            next()
          } else {
            next({
              name: '404-resource',
              params: { resource: i18n.t('ui.error_page.resource.page') },
            })
          }
        } else if (!isClient) {
          next()
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 404 || isNaN(parseInt(to.params.account_id))) {
            const routeName = !isClient ? '404-resource' : '404'
            const resource = !isClient ? 'cuenta' : 'página'
            next({ name: routeName, params: { resource } })
            Nprogress.done()
          }
        } else {
          // assuming network error
          next(networkErrorPage)
          Nprogress.done()
        }
      } finally {
        Nprogress.done()
      }
    },
    component: () => import(/* webpackChunkName: "dashboard-client" */ 'Pages/DashboardClient'),
    children: [
      {
        path: 'roadmap',
        name: 'roadmap',
      },
      {
        path: 'c/:card_id/:card_title',
        name: 'client-dashboard-modal',
        props: true,
        component: () =>
          import(/* webpackChunkName: "client-dashboard-modal" */ 'Pages/CardModalPage'),
      },
      {
        path: 'add-action',
        name: 'add-card-modal',
        meta: { largeModal: true },
        component: () => import(/* webpackChunkName: "add-card" */ 'Pages/CardCatalogue'),
      },
      // {
      //   path: 'hire-action',
      //   name: 'hire-card-modal',
      //   component: () => import(/* webpackChunkName: "add-card" */ 'Pages/CardCatalogue'),
      // },
      // {
      //   path: 'swap-pack',
      //   name: 'swap-pack-modal',
      //   component: () => import(/* webpackChunkName: "add-card" */ 'Pages/CardCatalogue'),
      // },
    ],
  },
]
